import Vue from 'vue'
import VueRouter from 'vue-router'
// import App from '../App.vue'
import MapCovid from '../views/Map.vue'
import Home from '../views/Home.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
 
Vue.use(VueAxios, axios)
Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/map",
      name: "Map",
      component: MapCovid
    },
    {
      path: "/stats",
      name: "Home",
      component: Home
    }
  ],
  mode: "history",
  base: process.env.ROUTER_BASE
});

// export default router
